export default "__VITE_ASSET__3c34c310__"